export const flowplayerKey = '$488948329469964'


export const salt = "axetv__100"

export const apiDomain = process.env.VUE_APP_API_PATH;

export const httpsUrl = process.env.VUE_APP_WEB_URL
export const httpUrl = process.env.VUE_APP_WEB_URL

export const adminUrl = process.env.NODE_ENV == 'development' ?
    'http://localhost:3000/#/__authorize' : 'https://admin.axetv.net/#/__authorize'

export const apiUrl = apiDomain + process.env.VUE_APP_API_PREFIX;
export const apiUrlAuth = apiUrl + "/auth";

export const mode = process.env.NODE_ENV;